import { render, staticRenderFns } from "./ComeBid.vue?vue&type=template&id=55ff35c7&scoped=true&"
import script from "./ComeBid.vue?vue&type=script&lang=js&"
export * from "./ComeBid.vue?vue&type=script&lang=js&"
import style0 from "./ComeBid.vue?vue&type=style&index=0&id=55ff35c7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff35c7",
  null
  
)

export default component.exports